import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";

export abstract class AbstractHttpService {
	constructor(private httpClient: HttpClient, private context: string) { }

	protected doGet<T>(path: string): Observable<T> {
		return this.httpClient.get<T>(`${this.context}${path}`, {
			observe: 'response'
		}).pipe(
			map((response: HttpResponse<T>) => response.body!)
		);
	}
	protected doPost<T>(path: string, payload: any): Observable<T> {
		return this.httpClient.post<T>(`${this.context}${path}`, payload, {
			observe: 'response'
		}).pipe(
			map((response: HttpResponse<T>) => response.body!)
		);
	}
	protected doUploadFile<T>(path: string, payload: any): Observable<HttpEvent<T>> {
		const formData = new FormData();
		formData.append('file', payload);

		return this.httpClient.post<T>(`${this.context}${path}`, formData, {
			reportProgress: true,
			observe: 'events'
		});
	}
	protected doUploadFileWithAuth<T>(path: string, jwtToken: string, payload: any): Observable<HttpEvent<T>> {
		let headers = new HttpHeaders();
		headers = headers.set('Authorization', `Bearer ${jwtToken}`);

		const formData = new FormData();
		formData.append('file', payload);

		return this.httpClient.post<T>(`${this.context}${path}`, formData, {
			headers: headers,
			reportProgress: true,
			observe: 'events'
		});
	}
	protected doDownloadFile(path: string): Observable<HttpResponse<Blob>> {
		return this.httpClient.get(`${this.context}${path}`, {
			responseType: 'blob',
			observe: 'response'
		}).pipe(tap(response => {
			const contentDisposition = response.headers.get('Content-Disposition');
			const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
			const filename = filenameMatch ? filenameMatch[1] : 'download.csv';

			const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });

			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = filename;
			link.click();

			window.URL.revokeObjectURL(link.href);
		}));
	}

	protected doDownloadFilePost(path: string, payload: any): Observable<HttpResponse<Blob>> {
		return this.httpClient.post(`${this.context}${path}`, payload, {
			responseType: 'blob',
			observe: 'response'
		}).pipe(tap(response => {
			const contentDisposition = response.headers.get('Content-Disposition');
			const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
			const filename = filenameMatch ? filenameMatch[1] : 'download.csv';

			const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });

			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = filename;
			link.click();

			window.URL.revokeObjectURL(link.href);
		}));
	}
}
